// The receipt is where the payment redirect lands, so a confirmation older than
// this is a revisit: a restored tab, a bookmark, or the link opened again.
const MAX_CONFIRM_AGE_SECONDS = 60 * 60;
const storageKey = (orderUuid) => `epms.purchaseTracked.${orderUuid}`;
/**
 * Whether the receipt should report the order as a purchase: not yet reported
 * from this browser, and confirmed shortly before the server sent it. Both
 * times are the server's, so a wrong device clock does not matter.
 */
export const shouldTrackPurchase = (order) => {
    // Null while the PSP callback is still pending, so the age is unknown.
    if (order.confirmTime !== null &&
        order.serverTime - order.confirmTime > MAX_CONFIRM_AGE_SECONDS) {
        return false;
    }
    try {
        return window.localStorage.getItem(storageKey(order.uuid)) === null;
    }
    catch (_a) {
        // No storage: the age check alone limits the duplicates.
        return true;
    }
};
/**
 * Call once the purchase has reached every provider, so that one dropped for
 * missing consent is reported again on the next load. localStorage, not
 * sessionStorage: a new tab or a restored one starts with an empty
 * sessionStorage and reported the order again.
 */
export const markPurchaseTracked = (orderUuid) => {
    try {
        window.localStorage.setItem(storageKey(orderUuid), "1");
    }
    catch (_a) {
        // No storage: see shouldTrackPurchase().
    }
};
